import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import 'element-plus/dist/index.css'
import router from './router'
import store from './store'
import './style.css'
import './assets/css/common/common.scss'
import App from './App.vue'
import {enumConfig} from './util/enum/index.js'
import { initCosAuth } from './util/common.js'

window.enumConfig = {...enumConfig}

// 初始化 COS 临时授权（图片访问用）
initCosAuth();

const app = createApp(App)

app.use(router)
app.use(store)
app.use(ElementPlus, {
  locale: zhCn,
})

app.mount('#app')
